// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__0dhyf","Cell":"EmployeeTable_Cell__Q7x1p","Paper":"EmployeeTable_Paper__-tcFA"};